import OrderLimitationsStore from './../../src/store/orderLimitations';
import shop from '@/store/shop';

export function getOrFetchOrderLimitations() {
  if (OrderLimitationsStore.isFetched()) {
    return OrderLimitationsStore.getValue();
  }
  return updateOrderLimitations();
}

export async function updateOrderLimitations() {
  if (!shop?.Shop.getValue()?.selectedShop?.productBuyLimit) return;
  const limitations = [
    shop.Shop.getValue().selectedShop.productBuyLimit,
    shop.Shop.getValue().selectedShop.weighedProductBuyLimit,
  ];
  OrderLimitationsStore.update(limitations);
  return limitations;
}

export default { getOrFetchOrderLimitations, updateOrderLimitations };
